import React from 'react'
import { MainDiv, NumberDiv, StudentDiv, StyledDivision } from './style'

const CompanyCard = ({ elgibileCount }) => {
  return (
    <MainDiv>
      <NumberDiv> {elgibileCount} </NumberDiv>
      <StudentDiv>Students</StudentDiv>

      <StyledDivision>
        As more details are entered, the algorithm refines results. An
        approximate candidate count will be shown here
      </StyledDivision>
    </MainDiv>
  )
}
export default CompanyCard
